import { DatePipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

import { FieldCommonComponent } from '../field-common.component';


@Component({
  providers: [DatePipe],
  selector: 'app-input-prime-datepicker',
  templateUrl: './input-prime-datepicker.component.html',
  styleUrls: ['./input-prime-datepicker.component.scss']
})
export class InputPrimeDatepickerComponent extends FieldCommonComponent implements OnInit {

  public dateTokenString: string;

  @Input() ptbr = {
    firstDayOfWeek: 1,
    dayNames: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
    dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
    monthNames: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro'],
    monthNamesShort: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
    today: 'Hoje',
    clear: 'Limpar'
  };
  @Input() maxDate: Date;
  @Input() minDate: Date;

  public dateOverlay = false;
  public dateOverlayAnimation = false;
  constructor(
    private readonly datePipe: DatePipe,
  ) {
    super();
  }

  ngOnInit() {
  }

  public applyDate() {
    this.control.setValue(this.datePipe.transform(this.control.value, 'dd/MM/yyyy'));
    this.showHideDatepicker(false);
  }

  public clearDate() {
    this.control.setValue('');
    this.showHideDatepicker(false);
  }

  // Exibe ou esconde o datepicker
  public showHideDatepicker(show: boolean) {
    if (show) {
      this.dateOverlay = show;
      setTimeout(() => {
        this.dateOverlayAnimation = show;
      }, 1);
    } else {
      this.dateOverlayAnimation = show;
      setTimeout(() => {
        this.dateOverlay = show;
      }, 200);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/formulario/input-prime-datepicker/input-prime-datepicker.component.ts